import { Component, OnInit, OnDestroy, Inject, ViewChild, ElementRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { YearService } from '../../../../shared-components/year/year.service';
import { UserPreferencesService } from '../../../../shared-components/user-preferences/user-preferences.service';
import { SchoolYearSettings } from '../../../../shared-components/year/school-year-settings.model';
import { ReportingService } from '../../reporting.service';
import { LoginService } from '../../../../shared-modules/login/login.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { formatDate } from '@angular/common';
import { CourseTerm } from '../../../../student360/student-schedule/course-term.model';
import * as moment from 'moment';
import { ReportV9 } from '../../models/report-v9.model';
import { ErrorList } from '../../../../shared-components/controls/error-prompt/error-list.model';
import { ReportQueueComponent } from '../../report-queue/report-queue.component';
import { ReportParameterV9 } from '../../models/report-parameter-v9.model';
import { LookupService } from '../../../../shared-components/lookup/lookup.service';
import { DataSource } from '../../models/data-source.model';
import { AttendanceHistoryByStudentPreferences, ReportParameters } from './attendance-history-by-class.model';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { TextMaskConfig } from 'angular2-text-mask/src/angular2TextMask';

@AutoUnsubscribe()
@Component({
  selector: 'app-attendance-history-by-class',
  templateUrl: './attendance-history-by-class.component.html',
  styleUrls: ['./attendance-history-by-class.component.css'],
})
export class AttendanceHistoryByClassComponent implements OnInit, OnDestroy {
  subscriptions: Subscription[] = [];
  schoolYearSettings: SchoolYearSettings;
  userPreferences: AttendanceHistoryByStudentPreferences;
  reportParameter = new ReportParameterV9();
  dialogRef: MatDialogRef<AttendanceHistoryByClassComponent>;
  term: CourseTerm;
  dataSource: MatTableDataSource<any>;
  gridColumns: string[] = ['SelectAll', 'Period', 'TermCode', 'SubjectCode', 'Section', 'AbbreviatedTitle', 'TeacherName', 'StudentCount', 'DaysGroupDescription'];
  report: ReportV9;
  ErrorCount: 0;
  parameters = [];
  param = [];
  reportParameters = new ReportParameters();
  // ERROR HANDLING
  // form: Form;
  errors: ErrorList[] = [];
  public numberMask: TextMaskConfig;
  showRun = false;
  reportType: number;
  reportName: string;
  workflowReport = false;
  inDebugMode = false;

  @ViewChild('ReportTitle', { read: ElementRef }) reportTitle: ElementRef;
  @ViewChild('Select', { read: ElementRef }) select: ElementRef;
  @ViewChild('FromPeriod', { read: ElementRef }) fromPeriod: ElementRef;
  @ViewChild('ToPeriod', { read: ElementRef }) toPeriod: ElementRef;
  @ViewChild('HistoryFrom', { read: ElementRef }) historyFrom: ElementRef;
  @ViewChild('HistoryTo', { read: ElementRef }) historyTo: ElementRef;
  @ViewChild('ResidencyCodeFrom', { read: ElementRef }) residencyCodeFrom: ElementRef;
  @ViewChild('ResidencyCodeTo', { read: ElementRef }) residencyCodeTo: ElementRef;
  @ViewChild('CategoryCodeFrom', { read: ElementRef }) categoryCodeFrom: ElementRef;
  @ViewChild('CategoryCodeTo', { read: ElementRef }) categoryCodeTo: ElementRef;
  @ViewChild('GradeLevelFrom', { read: ElementRef }) gradeLevelFrom: ElementRef;
  @ViewChild('GradeLevelTo', { read: ElementRef }) gradeLevelTo: ElementRef;
  @ViewChild('HistoryCountMin', { read: ElementRef }) historyCountMin: ElementRef;
  @ViewChild('HistoryCountMax', { read: ElementRef }) historyCountMax: ElementRef;
  @ViewChild('CurrentCodesTallyCountMin', { read: ElementRef }) currentCodesTallyCountMin: ElementRef;
  @ViewChild('CurrentCodesTallyCountMax', { read: ElementRef }) currentCodesTallyCountMax: ElementRef;
  @ViewChild('FullDay', { read: ElementRef }) fullDay: ElementRef;
  @ViewChild('DaysCountMin', { read: ElementRef }) daysCountMin: ElementRef;
  @ViewChild('DaysCountMax', { read: ElementRef }) daysCountMax: ElementRef;

  isDataExist = false;

  historyCodesToTally: DataSource[] = [];
  tallyTardiesCodes: DataSource[] = [];
  todaysCodesToTally: DataSource[] = [];
  daysCodes: DataSource[] = [];

  historyCodesToTallyIds = ''; // string; // number[] = [];
  tallyTardiesCodesIds: string; // number[] = [];
  todaysCodesToTallyIds: string;  // number[] = [];
  siteSectionIds = '';

  dayFullHalfCode: string;
  userPreferencePageName: string; // must match what's in UserPreferences DTO

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    AttendanceHistoryByClassDialogRef: MatDialogRef<AttendanceHistoryByClassComponent>,
    private dialog: MatDialog,
    private loginService: LoginService,
    private yearService: YearService,
    private userPreferencesService: UserPreferencesService,
    private reportingService: ReportingService,
    private lookupService: LookupService,
  ) {
    this.dialogRef = AttendanceHistoryByClassDialogRef;
    this.report = data.Report;
  }

  ngOnInit() {
    // NOTE: this is a C1 report and if user selects > 5 classes it will go to workflow, otherwise it will be a student attachment

    // if (this.inDebugMode) {
    //   console.log(this.report);
    // }

    this.inDebugMode = this.reportingService.inDebugMode;
    this.report.ReportName = this.reportName;
    this.numberMask = this.reportingService.getNumberMask();
    this.reportName = 'CreateAttendanceHistoryByClass';
    this.userPreferencePageName = '/HistoryByClassCO.aspx'; // '/AttendanceHistoryByClass.aspx'; // must match what's in UserPreferences DTO
    this.reportParameter.ReportTitle = 'Attendance History By Class';
    this.reportType = 2; // this.userPreferences.pub_intReportType;
    this.getLookups(); // DEV NOTE: GETTING PREFERENCES IN getLookups()
    this.getSchoolYearSettings();
    this.getTerms();
  }

  ngOnDestroy() {
  }

  cancelClick() {
    this.dialogRef.close();
  }

  getLookups() {

    this.subscriptions.push(
      // Residency Codes
      this.reportingService.getResidencyCodesLookup().subscribe(lookups => {
        this.reportParameters.ResidencyCodes = lookups;
      })

    );

    this.subscriptions.push(
      // Category Codes
      this.reportingService.getEnrollmentCategoriesLookup().subscribe(lookups => {
        this.reportParameters.CategoryCodes = lookups;
      })
    );

    this.subscriptions.push(
      // Grade Levels
      this.reportingService.getAllGradeLevelsLookup().subscribe(lookups => {
        this.reportParameters.GradeLevels = lookups;
      })
    );

    this.subscriptions.push(
      // Attendance Codes
      this.reportingService.getAttendanceCodesLookup(false, 0).subscribe(lookups => {
        this.reportParameters.AttendanceCodes = lookups;
        this.getUserPreferences(); // we need to get the attendance code lookups before calling this

        this.reportingService.populateDataSourceFromLookup(this.historyCodesToTally, this.reportParameters.AttendanceCodes);
        this.reportingService.populateDataSourceFromLookup(this.tallyTardiesCodes, this.reportParameters.AttendanceCodes);
        this.reportingService.populateDataSourceFromLookup(this.daysCodes, this.reportParameters.AttendanceCodes);
        this.reportingService.populateDataSourceFromLookup(this.todaysCodesToTally, this.reportParameters.AttendanceCodes);
      })

    );

  }

  getSchoolYearSettings() {
    this.yearService.getSchoolYearSettings(this.yearService.defaultYear.Id, this.yearService.defaultYear.SchoolID).subscribe(data => {
      this.schoolYearSettings = data;
      this.reportParameter.isValueChange = false;
      this.reportParameter.isReportList = false;
      this.reportParameter.PrintDate = formatDate(new Date, 'MM/dd/yyyy', 'en-US');
      this.reportParameter.AttendanceDate = moment(this.yearService.defaultYear.CurrentAttendanceDate).format('MM/DD/YYYY');
      this.reportParameter.FromPeriod = this.schoolYearSettings.MinumumPeriodPerDay;
      this.reportParameter.ToPeriod = this.schoolYearSettings.MaximumPeriodsPerDay;
      // const weekDay = moment.utc(this.reportParameter.AttendanceDate, 'MM/DD/YYYY').toDate().getDay();

      this.reportParameter.TermId = 0; // Default to All
      this.refreshGrid();
    });
  }

  getUserPreferences() {
    this.userPreferencesService.getUserPreferences(0, this.userPreferencePageName).subscribe(results => {

      if (!results) {
        return;
      }

      this.userPreferences = JSON.parse(results[0]);

      // if (this.reportingService.hasStringValueNotEmpty(this.userPreferences.pub_strReportTitle)) {
      //   this.reportParameter.ReportTitle = this.userPreferences.pub_strReportTitle;
      // }

      // SELECT ON HISTORY DATES
      this.reportParameters.SelectHistoryDates = this.userPreferences.pub_blnSelectHistoryDates;
      if (this.userPreferences.pub_datHistoryFrom != null && this.userPreferences.pub_datHistoryFrom != undefined) {
        this.reportParameters.HistoryFrom = this.reportingService.getMonthDayYear(this.userPreferences.pub_datHistoryFrom);
      }

      if (this.userPreferences.pub_datHistoryTo != null && this.userPreferences.pub_datHistoryTo != undefined) {
        this.reportParameters.HistoryTo = this.reportingService.getMonthDayYear(this.userPreferences.pub_datHistoryTo);
      }
      else {
        this.reportParameters.HistoryTo = this.reportingService.getMonthDayYear(new Date());
      }


      // SELECT ON RESIDENCY CODES
      this.reportParameters.SelectResidencyCodes = this.userPreferences.pub_blnSelectResidencyCodes;
      if (this.reportParameters.SelectResidencyCodes) {
        this.reportParameters.ResidencyCodeFrom = this.userPreferences.pub_strResidencyCodeFrom;
        this.reportParameters.ResidencyCodeTo = this.userPreferences.pub_strResidencyCodeTo;
      }

      // SELECT ON CATEGORY CODES
      this.reportParameters.SelectCategoryCodes = this.userPreferences.pub_blnSelectCategoryCodes;
      if (this.reportParameters.SelectCategoryCodes) {
        this.reportParameters.CategoryCodeFrom = this.userPreferences.pub_strCategoryCodeFrom;
        this.reportParameters.CategoryCodeTo = this.userPreferences.pub_strCategoryCodeTo;
      }

      this.reportParameters.SelectGradeLevels = this.userPreferences.pub_blnSelectGradeLevels;
      this.reportParameters.GradeLevelRankFrom = this.userPreferences.pub_strGradeLevelRankFrom;
      this.reportParameters.GradeLevelRankTo = this.userPreferences.pub_strGradeLevelRankTo;

      this.setGradeLevelFrom();
      this.setGradeLevelTo();

      // ******* HISTORY CODES TO TALLY ******************************************
      this.reportingService.setSelectedItemsFromUserPrefereneces(this.userPreferences.pub_strHistoryCodesToTally, this.historyCodesToTally);
      this.reportParameters.HistoryMinMax = this.userPreferences.pub_blnSelectHistoryCountMinMax;
      this.reportParameters.HistoryCountMin = this.userPreferences.pub_intHistoryCountMin.toString();
      this.reportParameters.HistoryCountMax = this.userPreferences.pub_intHistoryCountMax.toString();


      this.reportParameters.TallyTardies = this.userPreferences.pub_blnTallyTardies;
      this.tallyTardiesCodesIds = this.userPreferences.pub_strTallyTardiesCodesIds;

      if (this.userPreferences.pub_blnIncludeAllAbsences) {
        this.reportParameters.IncludeAllAbsences = true;
      }
      else {
        this.reportParameters.IncludeAllAbsences = false;
      }



      // PERIODS TO TALLY

      if (this.userPreferences.pub_blnOnlyPeriodsforEachSection) {
        this.reportParameters.OnlyPeriodsforEachSection = true;
      }
      else {
        this.reportParameters.OnlyPeriodsforEachSection = false;
      }

      this.reportParameters.Count1Day = this.userPreferences.pub_blnCount1PerDay;
      this.reportParameters.SplitABDays = this.userPreferences.pub_blnSplitABDays;

      // TALLY TARDIES

      this.historyCodesToTallyIds = this.userPreferences.pub_strHistoryCodesToTallyIds;
      this.reportingService.setSelectedItemsFromUserPrefereneces(this.userPreferences.pub_strTallyTardiesCodes, this.tallyTardiesCodes);


      // ******* DAYS FULL/HALF SELECT CODES ******************************************

      if (this.userPreferences.pub_blnDaysFullHalfSelect) {
        this.reportParameters.DaysFullHalf = this.userPreferences.pub_blnDaysFullHalfSelect;
        this.reportingService.setSelectedItemsFromUserPrefereneces(this.userPreferences.pub_strDayFullHalfCode, this.daysCodes);
        this.reportParameters.FullDay = this.userPreferences.pub_blnFullDay;
        this.reportParameters.HalfDay = this.userPreferences.pub_blnHalfDay;
        this.dayFullHalfCode = this.userPreferences.pub_strDayFullHalfCode;
      }
      else {
        this.reportParameters.DaysFullHalf = false;
        this.reportParameters.FullDay = false;
        this.reportParameters.HalfDay = false;
      }
      this.reportParameters.DaysCountMin = this.userPreferences.pub_intDaysCountMin;
      this.reportParameters.DaysCountMax = this.userPreferences.pub_intDaysCountMax;

      // ******* TODAY'S CURRENT CODES TALLY ******************************************

      if (this.userPreferences.pub_blnTodaysCurrentTally) {
        this.reportParameters.TodaysCurrentTally = this.userPreferences.pub_blnTodaysCurrentTally;
        this.reportingService.setSelectedItemsFromUserPrefereneces(this.userPreferences.pub_strTodaysCodesToTally, this.todaysCodesToTally);
        this.todaysCodesToTallyIds = this.userPreferences.pub_strTodaysCodesToTallyIds;
      }
      else {
        this.reportParameters.TodaysCurrentTally = false;
      }

      this.reportParameters.CurrentMinMax = this.userPreferences.pub_blnCurrentMinMax;
      this.reportParameters.CurrentCodesTallyCountMin = this.userPreferences.pub_intCurrentCodesTallyCountMin;
      this.reportParameters.CurrentCodesTallyCountMax = this.userPreferences.pub_intCurrentCodesTallyCountMax;


      // ******* CHECKBOXES AT END ******************************************
      this.reportParameters.DoubleSpaceAfterStudentName = this.userPreferences.pub_blnDoubleSpaceAfterStudentName;
      this.reportParameters.ShowHistoryRecords = this.userPreferences.pub_blnShowHistoryRecords;
      this.reportParameters.ShowOnlySelectedRecords = this.userPreferences.pub_blnShowOnlySelectedRecords;
      this.reportParameters.ShowComments = this.userPreferences.pub_blnShowComments;
      if (this.userPreferences.pub_blnIgnoreAttendance) {
        this.reportParameters.IgnoreAttendance = true;
      }
      else {
        this.reportParameters.IgnoreAttendance = false;
      }
      this.reportParameters.ShowPresentCount = this.userPreferences.pub_blnShowPresentCount;
    });
  }

  saveUserPreferences() {

    const UserPreferencesObj = this.userPreferences;
    UserPreferencesObj.pub_strReportTitle = this.reportParameter.ReportTitle;
    UserPreferencesObj.pub_intReportType = this.reportType; // C1
    UserPreferencesObj.pub_blnParentInfo = false;
    UserPreferencesObj.pub_strStudentSelectionStatus = 'Active';
    UserPreferencesObj.pub_blnSelectHistoryDates = this.reportParameters.SelectHistoryDates;
    if (this.reportParameters.SelectHistoryDates) {
      UserPreferencesObj.pub_datHistoryFrom = this.reportParameters.HistoryFrom;
      UserPreferencesObj.pub_datHistoryTo = this.reportParameters.HistoryTo;
    }
    else {
      UserPreferencesObj.pub_datHistoryFrom = null;
      UserPreferencesObj.pub_datHistoryTo = null;
    }
    UserPreferencesObj.pub_blnSelectResidencyCodes = this.reportParameters.SelectResidencyCodes;
    UserPreferencesObj.pub_strResidencyCodeFrom = this.reportParameters.ResidencyCodeFrom;
    UserPreferencesObj.pub_strResidencyCodeTo = this.reportParameters.ResidencyCodeTo;
    UserPreferencesObj.pub_blnSelectCategoryCodes = this.reportParameters.SelectCategoryCodes;
    UserPreferencesObj.pub_strCategoryCodeFrom = this.reportParameters.CategoryCodeFrom;
    UserPreferencesObj.pub_strCategoryCodeTo = this.reportParameters.CategoryCodeTo;
    UserPreferencesObj.pub_blnSelectGradeLevels = this.reportParameters.SelectGradeLevels;
    UserPreferencesObj.pub_strGradeLevelRankFrom = this.reportParameters.GradeLevelRankFrom;
    UserPreferencesObj.pub_strGradeLevelRankTo = this.reportParameters.GradeLevelRankTo;
    UserPreferencesObj.pub_strHistoryCodesToTallyIds = this.historyCodesToTallyIds;
    UserPreferencesObj.pub_strHistoryCodesToTally = this.reportingService.getSelectedItemsAsDelimitedString(this.historyCodesToTally, true, '', true);

    UserPreferencesObj.pub_blnCount1PerDay = this.reportParameters.Count1Day;
    UserPreferencesObj.pub_blnSplitABDays = this.reportParameters.SplitABDays;
    UserPreferencesObj.pub_strHistoryPeriodsToTally = '';
    UserPreferencesObj.pub_blnOnlyPeriodsforEachSection = this.reportParameters.OnlyPeriodsforEachSection;

    UserPreferencesObj.pub_blnSelectHistoryCountMinMax = this.reportParameters.HistoryMinMax;
    UserPreferencesObj.pub_intHistoryCountMin = this.reportParameters.HistoryCountMin;
    UserPreferencesObj.pub_intHistoryCountMax = this.reportParameters.HistoryCountMax;

    UserPreferencesObj.pub_blnTallyTardies = this.reportParameters.TallyTardies;
    UserPreferencesObj.pub_strTallyTardiesCodesIds = this.tallyTardiesCodesIds;
    UserPreferencesObj.pub_strTallyTardiesCodes = this.reportingService.getSelectedItemsAsDelimitedString(this.tallyTardiesCodes, true, '', true);

    UserPreferencesObj.pub_blnDaysFullHalfSelect = this.reportParameters.DaysFullHalf;
    UserPreferencesObj.pub_blnFullDay = this.reportParameters.FullDay;
    UserPreferencesObj.pub_blnHalfDay = this.reportParameters.HalfDay;
    UserPreferencesObj.pub_strDayFullHalfCode = this.dayFullHalfCode;
    UserPreferencesObj.pub_intDaysCountMin = this.reportParameters.DaysCountMin;
    UserPreferencesObj.pub_intDaysCountMax = this.reportParameters.DaysCountMax;
    UserPreferencesObj.pub_blnTodaysCurrentTally = this.reportParameters.TodaysCurrentTally;
    UserPreferencesObj.pub_strTodaysCodesToTallyIds = this.reportingService.hasStringValueNotEmpty(this.todaysCodesToTallyIds) ? this.todaysCodesToTallyIds : '';
    UserPreferencesObj.pub_strTodaysCodesToTally = this.reportingService.getSelectedItemsAsDelimitedString(this.todaysCodesToTally, true, '', true);
    UserPreferencesObj.pub_blnCurrentMinMax = this.reportParameters.CurrentMinMax;
    UserPreferencesObj.pub_intCurrentCodesTallyCountMin = this.reportParameters.CurrentCodesTallyCountMin;
    UserPreferencesObj.pub_intCurrentCodesTallyCountMax = this.reportParameters.CurrentCodesTallyCountMax;
    UserPreferencesObj.pub_blnDoubleSpaceAfterStudentName = this.reportParameters.DoubleSpaceAfterStudentName;
    UserPreferencesObj.pub_blnShowHistoryRecords = this.reportParameters.ShowHistoryRecords;
    UserPreferencesObj.pub_blnShowOnlySelectedRecords = this.reportParameters.ShowOnlySelectedRecords;
    UserPreferencesObj.pub_blnShowComments = this.reportParameters.ShowComments;
    UserPreferencesObj.pub_blnShowCurrentAtndSteps = false;
    UserPreferencesObj.pub_blnIgnoreAttendance = this.reportParameters.IgnoreAttendance;
    UserPreferencesObj.pub_blnNotEnrolled = false;
    UserPreferencesObj.pub_blnIncludeAllAbsences = this.reportParameters.IncludeAllAbsences;
    UserPreferencesObj.pub_blnConsecutiveDays = false;
    UserPreferencesObj.pub_blnShowPresentCount = this.reportParameters.ShowPresentCount;

    const xmlStream: string[] = [];
    xmlStream.push(JSON.stringify(UserPreferencesObj));

    this.userPreferencesService.saveUserPreferences(0, this.userPreferencePageName, xmlStream, 0, '').subscribe(response => { }
      , err => {
        // On Error
        console.log(err);
      });

  }

  getTerms() {
    this.reportingService.getTermsforCourses(0, this.yearService.defaultYear.SiteYearId).subscribe(data => {
      this.reportParameter.Terms = data.filter(function (element) { return (element.TermTypeId != 2); });
      this.term = new CourseTerm();
      this.term.Id = 0;
      this.term.LongDescription = ' All Terms';
      this.reportParameter.Terms.push(this.term);
    });
  }


  changeValue() {
    this.reportParameter.isValueChange = true;
    if (this.reportParameter.FromPeriod > this.schoolYearSettings.MaximumPeriodsPerDay || this.reportParameter.FromPeriod < this.schoolYearSettings.MinumumPeriodPerDay) {
      this.reportParameter.FromPeriod = this.schoolYearSettings.MinumumPeriodPerDay;
    }
    if (this.reportParameter.ToPeriod > this.schoolYearSettings.MaximumPeriodsPerDay || this.reportParameter.ToPeriod < this.schoolYearSettings.MinumumPeriodPerDay) {
      this.reportParameter.ToPeriod = this.schoolYearSettings.MaximumPeriodsPerDay;
    }
  }

  cancelShowReportParameters() {
    this.dialogRef.close();
  }

  refreshGrid() {
    this.errors = [];
    if ((this.reportParameter.FromPeriod == undefined || this.reportParameter.FromPeriod == 0 || this.reportParameter.FromPeriod == null) && $.isNumeric(this.reportParameter.FromPeriod) == false) {
      this.errors.push({
        fieldName: 'From Period',
        errorMsg: 'Field is required',
        fieldRef: this.fromPeriod
      });
    }
    if ((this.reportParameter.ToPeriod == undefined || this.reportParameter.ToPeriod == 0 || this.reportParameter.ToPeriod == null) && $.isNumeric(this.reportParameter.ToPeriod) == false) {
      this.errors.push({
        fieldName: 'To Period',
        errorMsg: 'Field is required',
        fieldRef: this.toPeriod
      });
    }


    if (this.errors.length == 0) {
      this.reportParameter.ReportGridData = [];
      this.reportingService.getTeacherPreviewGridData(this.yearService.defaultYear.SiteYearId, this.reportParameter.TermId, moment.utc(this.reportParameter.AttendanceDate, 'MM-DD-YYYY HH:mm a').toDate(), this.reportParameter.FromPeriod, this.reportParameter.ToPeriod).subscribe(results => {

        // console.log(results);

        this.reportParameter.ReportGridData = results;
        if (this.reportParameter.ReportGridData.length > 0) {
          this.isDataExist = true;
        }
        else {
          this.isDataExist = false;
        }
        this.reportParameter.isValueChange = false;
        this.dataSource = new MatTableDataSource(this.reportParameter.ReportGridData);
        this.reportParameter.selectAllReportGridData = true;
        this.selectAll(true);
      });
    }
  }

  selectAll(value) {
    this.reportParameter.ReportGridData.forEach(o => {
      o.Select = value;
    }
    );
  }

  selectClass() {
    const result = this.reportParameter.ReportGridData.filter(o => o.Select == false);
    if (result.length > 0) {
      this.reportParameter.selectAllReportGridData = false;
    }
    else if (result.length == 0) {
      this.reportParameter.selectAllReportGridData = true;
    }
  }

  checkErrors() {
    this.errors = [];

    const selectedGridData = this.reportParameter.ReportGridData.filter(o => o.Select);
    if (selectedGridData.length == 0) {
      this.errors.push({
        fieldName: '',
        errorMsg: 'No Classes Selected!',
        fieldRef: this.select
      });
    }

    if (selectedGridData.length > 0) { // change back to > 5 if issue with student attachment is addressed, JS always went to workflow
      this.workflowReport = true;
    }
    // else {
    //   this.workflowReport = false;
    // }

    if (this.reportParameter.isValueChange) {
      this.errors.push({
        fieldName: '',
        errorMsg: '<span><a style="cursor:pointer;text-decoration:underline;text-wrap:none;white-space: nowrap;">Selection Criteria Changed </a>  Please click Update Display button again!<span>',
        fieldRef: null
      });
    }

    // Report Title

    if (!this.reportingService.hasStringValueNotEmpty(this.reportParameter.ReportTitle)) {
      this.errors.push({
        fieldName: 'Report Title',
        errorMsg: 'Field is required',
        fieldRef: this.reportTitle
      });
    }

    // History Dates

    if (this.reportParameters.SelectHistoryDates && (this.reportParameters.HistoryFrom == undefined || this.reportParameters.HistoryFrom == null)) {
      this.errors.push({
        fieldName: 'History From',
        errorMsg: 'Field is required',
        fieldRef: this.historyFrom
      });
    }

    if (this.reportParameters.SelectHistoryDates && (this.reportParameters.HistoryTo == undefined || this.reportParameters.HistoryTo == null)) {
      this.errors.push({
        fieldName: 'History To',
        errorMsg: 'Field is required',
        fieldRef: this.historyTo
      });
    }

    // Residency Codes

    if (this.reportParameters.SelectResidencyCodes) {
      if (this.reportParameters.ResidencyCodeFrom == undefined || this.reportParameters.ResidencyCodeFrom.trim() == '' || this.reportParameters.ResidencyCodeFrom == null) {
        this.errors.push({
          fieldName: 'Residency Code From',
          errorMsg: 'Field is required',
          fieldRef: this.residencyCodeFrom
        });
      }
      if (this.reportParameters.ResidencyCodeTo == undefined || this.reportParameters.ResidencyCodeTo.trim() == '' || this.reportParameters.ResidencyCodeTo == null) {
        this.errors.push({
          fieldName: 'Residency Code To',
          errorMsg: 'Field is required',
          fieldRef: this.residencyCodeTo
        });
      }
    }

    // Category Codes

    if (this.reportParameters.SelectCategoryCodes) {
      if (this.reportParameters.CategoryCodeFrom == undefined || this.reportParameters.CategoryCodeFrom.trim() == '' || this.reportParameters.CategoryCodeFrom == null) {
        this.errors.push({
          fieldName: 'Category Code From',
          errorMsg: 'Field is required',
          fieldRef: this.categoryCodeFrom
        });
      }
      if (this.reportParameters.CategoryCodeTo == undefined || this.reportParameters.CategoryCodeTo.trim() == '' || this.reportParameters.CategoryCodeTo == null) {
        this.errors.push({
          fieldName: 'Category Code To',
          errorMsg: 'Field is required',
          fieldRef: this.categoryCodeTo
        });
      }
    }

    // Grade Levels

    if (this.reportParameters.SelectGradeLevels) {
      if (this.reportParameters.GradeLevelFrom == undefined || this.reportParameters.GradeLevelFrom.trim() == '' || this.reportParameters.GradeLevelFrom == null) {
        this.errors.push({
          fieldName: 'Grade Level From',
          errorMsg: 'Field is required',
          fieldRef: this.gradeLevelFrom
        });
      }
      if (this.reportParameters.GradeLevelTo == undefined || this.reportParameters.GradeLevelTo.trim() == '' || this.reportParameters.GradeLevelTo == null) {
        this.errors.push({
          fieldName: 'Grade Level To',
          errorMsg: 'Field is required',
          fieldRef: this.gradeLevelTo
        });
      }
    }

    // Tally Tardies

    if (this.reportParameters.TallyTardies) {
      if (this.reportingService.getSelectedItemsAsDelimitedString(this.tallyTardiesCodes, true, '', true) == '') {
        this.errors.push({
          fieldName: null,
          errorMsg: 'You must select at least one code for Tally Tardies',
          fieldRef: null
        });
      }
    }

    // history min/max

    // if (this.inDebugMode) {
    //   console.log('this.reportParameters.HistoryMinMax');
    //   console.log(this.reportParameters.HistoryMinMax);
    //   console.log('this.reportParameters.HistoryCountMin');
    //   console.log(this.reportParameters.HistoryCountMin);
    //   console.log('this.reportParameters.HistoryCountMax');
    //   console.log(this.reportParameters.HistoryCountMax);

    // }

    if (this.reportParameters.HistoryMinMax) {

      if (!this.reportingService.hasStringValueNotEmpty(this.reportParameters.HistoryCountMin)) {
        this.errors.push({
          fieldName: 'History Count Min',
          errorMsg: 'Field is required',
          fieldRef: this.historyCountMin
        });
      }

      if (!this.reportingService.hasStringValueNotEmpty(this.reportParameters.HistoryCountMax)) {
        this.errors.push({
          fieldName: 'History Count Max',
          errorMsg: 'Field is required',
          fieldRef: this.historyCountMax
        });
      }

      if (this.reportingService.minIsGreaterThanMax(this.reportParameters.HistoryCountMin, this.reportParameters.HistoryCountMax)) {
        this.errors.push({
          fieldName: 'History Count Min',
          errorMsg: 'Min must not be greater than Max',
          fieldRef: this.historyCountMin
        });

      }

    } // END history min/max

    // Days (Full/Half)

    if (this.reportParameters.DaysFullHalf) {

      if (this.reportingService.getSelectedItemsAsDelimitedString(this.daysCodes, true, '', true) == '') {
        this.errors.push({
          fieldName: null, // 'Days (Full/Half)',
          errorMsg: 'You must select at least one code for Days (Full/Half)',
          fieldRef: null // this.daysFullHalfSelect
        });
      }

      if (this.reportParameters.FullDay == false && this.reportParameters.HalfDay == false) {
        this.errors.push({
          fieldName: 'FullDay/HalfDay',
          errorMsg: 'Select FullDay or HalfDay',
          fieldRef: this.fullDay
        });
      }


      if (!this.reportingService.hasStringValueNotEmpty(this.reportParameters.DaysCountMin)) {
        this.errors.push({
          fieldName: 'Days Count Min',
          errorMsg: 'Field is required',
          fieldRef: this.daysCountMin
        });
      }

      if (!this.reportingService.hasStringValueNotEmpty(this.reportParameters.DaysCountMax)) {
        this.errors.push({
          fieldName: 'Days Count Max',
          errorMsg: 'Field is required',
          fieldRef: this.daysCountMax
        });
      } 

      if (this.reportingService.minIsGreaterThanMax(this.reportParameters.DaysCountMin, this.reportParameters.DaysCountMax)) {
        this.errors.push({
          fieldName: 'Days Count Min',
          errorMsg: 'Min must not be greater than Max',
          fieldRef: this.daysCountMin
        });

      } 
      
    } // END Days (Full/Half)

      // Today's Current Codes Tally

      if (this.reportParameters.TodaysCurrentTally) {
        if (this.reportingService.getSelectedItemsAsDelimitedString(this.todaysCodesToTally, true, '', true) == '') {
          this.errors.push({
            fieldName: null,
            errorMsg: 'You must select at least one code for Today`s Current Codes Tally',
            fieldRef: null
          });
        }
      }

      if (this.reportParameters.CurrentMinMax) {

        if (!this.reportingService.hasStringValueNotEmpty(this.reportParameters.CurrentCodesTallyCountMin)) {
          this.errors.push({
            fieldName: 'Tally Count Min',
            errorMsg: 'Field is required',
            fieldRef: this.currentCodesTallyCountMin
          });
        }

        if (!this.reportingService.hasStringValueNotEmpty(this.reportParameters.CurrentCodesTallyCountMax)) {
          this.errors.push({
            fieldName: 'Tally Count Max',
            errorMsg: 'Field is required',
            fieldRef: this.currentCodesTallyCountMax
          });
        }

        if (this.reportingService.minIsGreaterThanMax(this.reportParameters.CurrentCodesTallyCountMin, this.reportParameters.CurrentCodesTallyCountMax)) {
          this.errors.push({
            fieldName: 'Tally Count Min',
            errorMsg: 'Min must not be greater than Max',
            fieldRef: this.currentCodesTallyCountMin
          });

        }

      } // END current tally min/max
   // } -- ONE-15181 - I moved this above as I noticed these other validations were not occurring unless days full/half was checked while working on ticket
  }

  setReportParameters() {
    this.reportParameter.PrintDate = this.reportingService.getMonthDayYear(new Date()).toString();

    this.parameters = [];
    this.param = [];
    this.param.push({ ParamName: 'strReportSiteHeader', ParamStringValue: this.yearService.defaultYear.SchoolName });
    this.param.push({ ParamName: 'strReportSiteAddress', ParamStringValue: '' });
    this.param.push({ ParamName: 'strReportDate', ParamStringValue: ((new Date().getMonth() + 1) + '/' + new Date().getDate() + '/' + new Date().getFullYear()) });
    this.param.push({ ParamName: 'strReportTitle', ParamStringValue: this.reportParameter.ReportTitle });
    this.param.push({ ParamName: 'strSiteYearCode', ParamStringValue: this.yearService.defaultYear.SchoolCode + '' + this.yearService.defaultYear.AYIdentifier });
    this.param.push({ ParamName: 'strSiteTypeCode', ParamStringValue: 'HS' });
    this.param.push({ ParamName: 'lngSiteYearId', ParamStringValue: this.yearService.defaultYear.SiteYearId });
    this.param.push({ ParamName: 'intSiteYearId', ParamStringValue: this.yearService.defaultYear.SiteYearId });
    this.param.push({ ParamName: 'strUserName', ParamStringValue: ' ' + this.reportingService.currentUser.UserName });
    this.param.push({ ParamName: 'datCurrentAttendanceDate', ParamStringValue: ((new Date().getMonth() + 1) + '/' + new Date().getDate() + '/' + new Date().getFullYear()) });
    this.param.push({ ParamName: 'bytReportType', ParamStringValue: this.reportType });
    this.param.push({ ParamName: 'strStudentSelectionStatus', ParamStringValue: 'Active' });

    const selectedGridData = this.reportParameter.ReportGridData.filter(o => o.Select);
    let selectedSectionIds = '';
    for (let x = 0; x < selectedGridData.length; x++) {
      if (selectedSectionIds == '') {
        selectedSectionIds += selectedGridData[x].SiteSectionId;
      } else {
        selectedSectionIds = selectedSectionIds + ',' + selectedGridData[x].SiteSectionId;
      }
    }
    this.siteSectionIds = selectedSectionIds;

    if (this.siteSectionIds != '') {
      this.param.push({ ParamName: 'strSiteSectionIds', ParamStringValue: this.siteSectionIds });
    }

    // residency codes

    if (this.reportingService.hasStringValueNotEmpty(this.reportParameters.ResidencyCodeFrom)) {
      this.param.push({ ParamName: 'strResidencyCodeFrom', ParamStringValue: this.reportParameters.ResidencyCodeFrom });
    }

    if (this.reportingService.hasStringValueNotEmpty(this.reportParameters.ResidencyCodeTo)) {
      this.param.push({ ParamName: 'strResidencyCodeTo', ParamStringValue: this.reportParameters.ResidencyCodeTo });
    }

    // category codes

    if (this.reportingService.hasStringValueNotEmpty(this.reportParameters.CategoryCodeFrom)) {
      this.param.push({ ParamName: 'strCategoryCodeFrom', ParamStringValue: this.reportParameters.CategoryCodeFrom });
    }

    if (this.reportingService.hasStringValueNotEmpty(this.reportParameters.CategoryCodeTo)) {
      this.param.push({ ParamName: 'strCategoryCodeTo', ParamStringValue: this.reportParameters.CategoryCodeTo });
    }


    // grade levels

    if (this.reportParameters.SelectGradeLevels && this.reportingService.hasStringValueNotEmpty(this.reportParameters.GradeLevelFrom)) {
      this.param.push({ ParamName: 'strGradeLevelCodeFrom', ParamStringValue: this.reportParameters.GradeLevelFrom });

      const gradeLevelRankFrom = this.reportParameters.GradeLevelRankFrom.split(',')[0];
      this.param.push({ ParamName: 'strGradeLevelRankFrom', ParamStringValue: gradeLevelRankFrom });
      // param = param + ", {ParamName: 'strGradeLevelCodeFrom', ParamStringValue: '" + this.reportParameters.GradeLevelsRankFrom.Code + "'}";
      // param = param + ", {ParamName: 'strGradeLevelRankFrom', ParamStringValue: '" + this.reportParameters.GradeLevelsRankFrom.Ranking + "'}";
    }

    if (this.reportParameters.SelectGradeLevels && this.reportingService.hasStringValueNotEmpty(this.reportParameters.GradeLevelTo)) {
      this.param.push({ ParamName: 'strGradeLevelCodeTo', ParamStringValue: this.reportParameters.GradeLevelTo });
      const gradeLevelRankTo = this.reportParameters.GradeLevelRankTo.split(',')[0];
      this.param.push({ ParamName: 'strGradeLevelRankTo', ParamStringValue: gradeLevelRankTo });
      // param = param + ", {ParamName: 'strGradeLevelCodeTo', ParamStringValue: '" + this.reportParameters.GradeLevelsRankTo.Code + "'}";
      // param = param + ", {ParamName: 'strGradeLevelRankTo', ParamStringValue: '" + this.reportParameters.GradeLevelsRankTo.Ranking + "'}";
    }


    // select history dates

    if (this.reportParameters.SelectHistoryDates) {

      // if (this.inDebugMode) {
      //   console.log(this.reportParameters.HistoryFrom);
      //   console.log(this.reportParameters.HistoryTo);
      // }

      // this.param.push({ ParamName: 'datHistoryDateFrom', ParamStringValue: this.reportingService.getMonthDayYear(this.reportParameters.HistoryFrom) });
      this.param.push({ ParamName: 'datHistoryDateFrom', ParamStringValue: ((this.reportParameters.HistoryFrom.getMonth() + 1) + '/' + this.reportParameters.HistoryFrom.getDate() + '/' + this.reportParameters.HistoryFrom.getFullYear()) });


      this.param.push({ ParamName: 'datHistoryDateTo', ParamStringValue: ((this.reportParameters.HistoryTo.getMonth() + 1) + '/' + this.reportParameters.HistoryTo.getDate() + '/' + this.reportParameters.HistoryTo.getFullYear()) });
      // this.param.push({ ParamName: 'datHistoryDateTo', ParamStringValue: this.reportParameters.HistoryTo });
    }

    this.param.push({ ParamName: 'strAttndHistoryCodesToTally', ParamStringValue: this.historyCodesToTallyIds });
    this.param.push({ ParamName: 'blnOnlyPeriodsEachSection', ParamStringValue: this.reportParameters.OnlyPeriodsforEachSection });
    this.param.push({ ParamName: 'blnCount1PerDay', ParamStringValue: this.reportParameters.Count1Day });


    if (this.reportParameters.HistoryMinMax && this.reportParameters.HistoryCountMin != undefined && this.reportParameters != null) {
      this.param.push({ ParamName: 'intHistoryCountMin', ParamStringValue: this.reportParameters.HistoryCountMin });
    }

    if (this.reportParameters.HistoryMinMax && this.reportParameters.HistoryCountMax != undefined && this.reportParameters != null) {
      this.param.push({ ParamName: 'intHistoryCountMax', ParamStringValue: this.reportParameters.HistoryCountMax });
    }

    if (!this.reportingService.hasStringValueNotEmpty(this.tallyTardiesCodesIds)) {
      this.tallyTardiesCodesIds = '';
    }

    this.param.push({ ParamName: 'strTardiesCodesToTally', ParamStringValue: (this.reportParameters.TallyTardies ? this.tallyTardiesCodesIds : '') });
    this.param.push({ ParamName: 'blnFullDay', ParamStringValue: (this.reportParameters.DaysFullHalf ? this.reportParameters.FullDay : false) });
    this.param.push({ ParamName: 'blnHalfDay', ParamStringValue: (this.reportParameters.DaysFullHalf ? this.reportParameters.HalfDay : false) });

    if (this.reportParameters.DaysFullHalf && this.dayFullHalfCode != '') {
      this.dayFullHalfCode = this.reportingService.getSelectedItemsAsDelimitedString(this.daysCodes, true, ',', true);
      this.param.push({ ParamName: 'strDayFullHalfCodes', ParamStringValue: this.dayFullHalfCode });
    }

    // days count

    if (this.reportParameters.DaysFullHalf && this.reportParameters.DaysCountMin != undefined && this.reportParameters.DaysCountMin != null) {
      this.param.push({ ParamName: 'intDaysCountMin', ParamStringValue: this.reportParameters.DaysCountMin });
    }

    if (this.reportParameters.DaysFullHalf && this.reportParameters.DaysCountMax != undefined && this.reportParameters.DaysCountMax != null) {
      this.param.push({ ParamName: 'intDaysCountMax', ParamStringValue: this.reportParameters.DaysCountMax });
    }

    // todays

    this.param.push({ ParamName: 'strTodayCodesToTally', ParamStringValue: (this.reportParameters.TodaysCurrentTally ? this.todaysCodesToTallyIds : '') });


    if (this.reportParameters.CurrentMinMax && this.reportParameters.CurrentCodesTallyCountMin != undefined && this.reportParameters.CurrentCodesTallyCountMin != null) {
      this.param.push({ ParamName: 'intTodayCountMin', ParamStringValue: this.reportParameters.CurrentCodesTallyCountMin });
    }
    if (this.reportParameters.CurrentMinMax && this.reportParameters.CurrentCodesTallyCountMax != undefined && this.reportParameters.CurrentCodesTallyCountMax != null) {
      this.param.push({ ParamName: 'intTodayCountMax', ParamStringValue: this.reportParameters.CurrentCodesTallyCountMax });
    }

    // checkboxes
    this.param.push({ ParamName: 'blnDoubleSpaceAfterStudentName', ParamStringValue: this.reportParameters.DoubleSpaceAfterStudentName });
    this.param.push({ ParamName: 'blnSplitABDays', ParamStringValue: this.reportParameters.SplitABDays });
    this.param.push({ ParamName: 'blnShowHistoryRecords', ParamStringValue: this.reportParameters.ShowHistoryRecords });
    this.param.push({ ParamName: 'blnShowOnlySelectedRecords', ParamStringValue: this.reportParameters.ShowOnlySelectedRecords });
    this.param.push({ ParamName: 'blnShowComments', ParamStringValue: this.reportParameters.ShowComments });
    this.param.push({ ParamName: 'blnShowCurrentAttndSteps', ParamStringValue: false });
    this.param.push({ ParamName: 'blnIgnoreAttendancePrior', ParamStringValue: this.reportParameters.IgnoreAttendance });
    this.param.push({ ParamName: 'blnIncludeAllAbsences', ParamStringValue: this.reportParameters.IncludeAllAbsences });
    this.param.push({ ParamName: 'blnExport', ParamStringValue: false });
    this.param.push({ ParamName: 'blnParentInfo', ParamStringValue: false });
    this.param.push({ paramname: 'blnShowPresentCount', ParamStringValue: this.reportParameters.ShowPresentCount });

    const stringifiedParameters = JSON.stringify(this.param);
    this.parameters = [];
    this.parameters.push(stringifiedParameters);
  }

  runClick() {
    this.checkErrors();
    if (this.errors.length == 0) {
      this.getSelectedIdsAsCommaDelimitedString();
      this.setReportParameters();
      this.saveUserPreferences();
      if (this.workflowReport) {
        this.addToReportQueue();
      } else {
        this.openStudentAttachment();
      }
      this.dialogRef.close();
    }
  }

  setGradeLevelFrom() {
    if (this.reportParameters.SelectGradeLevels && this.reportParameters.GradeLevelRankFrom.includes(',')) {
      this.reportParameters.GradeLevelFrom = this.reportParameters.GradeLevelRankFrom.split(',')[1];
    }
  }

  setGradeLevelTo() {
    if (this.reportParameters.SelectGradeLevels && this.reportParameters.GradeLevelRankTo.includes(',')) {
      this.reportParameters.GradeLevelTo = this.reportParameters.GradeLevelRankTo.split(',')[1];
    }
  }

  setGradeLevelRankFrom() {
    if (this.reportParameters.SelectGradeLevels && this.reportingService.hasStringValueNotEmpty(this.reportParameters.GradeLevelFrom)) {
      for (let x = 0; x < this.reportParameters.GradeLevels.length; x++) {
        if (this.reportParameters.GradeLevelFrom == this.reportParameters.GradeLevels[x].Code) {
          this.reportParameters.GradeLevelRankFrom = this.reportParameters.GradeLevels[x].Id + ',' + this.reportParameters.GradeLevels[x].Code;
          break;
        }
      }
    }
  }

  setGradeLevelRankTo() {
    if (this.reportParameters.SelectGradeLevels && this.reportingService.hasStringValueNotEmpty(this.reportParameters.GradeLevelTo)) {
      for (let x = 0; x < this.reportParameters.GradeLevels.length; x++) {
        if (this.reportParameters.GradeLevelTo == this.reportParameters.GradeLevels[x].Code) {
          this.reportParameters.GradeLevelRankTo = this.reportParameters.GradeLevels[x].Id + ',' + this.reportParameters.GradeLevels[x].Code;
          break;
        }
      }
    }
  }

  addToReportQueue() {
    this.reportingService.runV9Report(this.reportName, this.reportType, this.workflowReport, this.parameters).subscribe(response => {
      setTimeout(() => {
        this.openReportQueueList();
      }, 500);
    }
      , err => {
        // On Error
        console.log(err);
      });
  }

  openStudentAttachment() {
    this.reportingService.openStudentAttachmentReport(0, this.reportName, '', '', '', this.parameters, this.reportType);
  }



  handleCheckboxAll(attCode: DataSource, event: boolean, dataSourceArray: DataSource[]) {
    this.reportingService.handleCheckboxAll(attCode, dataSourceArray);
  }

  nextClick() {
    this.showRun = true;
  }

  prevClick() {
    this.showRun = false;
  }

  openReportQueueList() {
    const reportQueueDialogRef = this.dialog.open(ReportQueueComponent, {
      panelClass: 'tyl-mat-dialog',
      disableClose: true,
    });
  }

  getSelectedIdsAsCommaDelimitedString() {
    this.historyCodesToTallyIds = this.reportingService.getSelectedItemsAsDelimitedString(this.historyCodesToTally, true, ',', true);
    this.tallyTardiesCodesIds = this.reportingService.getSelectedItemsAsDelimitedString(this.tallyTardiesCodes, true, ',', true);
    this.todaysCodesToTallyIds = this.reportingService.getSelectedItemsAsDelimitedString(this.todaysCodesToTally, true, ',', true);
    this.dayFullHalfCode = this.reportingService.getSelectedItemsAsDelimitedString(this.daysCodes, true, '', true);
  }
}